// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.osLBp1Fs39k3QPMxuj2J{background:var(--background-primary-inverted-primary);border-radius:8px;flex-direction:column;gap:8px;padding:8px 0;display:flex}.osLBp1Fs39k3QPMxuj2J.P8TqaAXvww2IXxxY135M{box-shadow:0 20px 50px rgba(18,21,23,.05),0 10px 30px -5px rgba(18,21,23,.1),0 0 0 1px rgba(18,21,23,.05)}.B9QlDUOjBOcj6LL7Wd3f{flex-direction:column;justify-content:center;align-self:stretch;align-items:flex-start;gap:8px;padding:8px 24px 0;display:flex}.L2P7VRCrD45rcB_SINhO{padding-left:6px}.SM0ug5XEewE6CNqU1F4M{justify-content:center;width:20px;display:flex}.rFXNLpuvLDEhmzgMzMgX{background:var(--black-30);border-radius:10px;width:2px;height:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `osLBp1Fs39k3QPMxuj2J`,
	"isDragging": `P8TqaAXvww2IXxxY135M`,
	"scheduleWrap": `B9QlDUOjBOcj6LL7Wd3f`,
	"wrapArrow": `L2P7VRCrD45rcB_SINhO`,
	"wrapLine": `SM0ug5XEewE6CNqU1F4M`,
	"line": `rFXNLpuvLDEhmzgMzMgX`
};
export default ___CSS_LOADER_EXPORT___;
